var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.87691 15.3791V15.8325L4.55633 15.5119L0.47014 11.4257L0.337349 11.2929L0.47014 11.1601L0.904096 10.7262L1.03689 10.5934L1.16968 10.7262L3.88679 13.4434V1.73416V1.54637H4.07458H4.68912H4.87691V1.73416V15.3791Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.37559
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99063 15.4401H8.80283V15.2523V1.60739V1.15401L9.12342 1.4746L13.2096 5.56079L13.3424 5.69358L13.2096 5.82637L12.7756 6.26033L12.6429 6.39312L12.5101 6.26033L9.79285 3.54311V15.2523V15.4401H9.60505H8.99063Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.37559
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.77c0b03ed66a22ee2a71593fd51b5cdc.svg";
export { ForwardRef as ReactComponent };